import { _ as _class_call_check } from "@swc/helpers/_/_class_call_check";
import { _ as _create_class } from "@swc/helpers/_/_create_class";
import { _ as _type_of } from "@swc/helpers/_/_type_of";
var __decorate = this && this.__decorate || function(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : _type_of(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/* eslint-disable complexity */ import { CONDUCTOR_FUNCTIONAL_MODAL, DIGEST_ENTRYPOINT_MODAL_QUERY_PARAM, FAIRE_DIRECT_CREDIT_FAQ, FAIRE_DIRECT_FOI, FAIRE_DIRECT_MARKETPLACE_INCENTIVE_MODAL, FIRST_ORDER_INCENTIVE_MODAL, FREE_RETURNS_MODAL_QUERY_PARAM_VALUE, IDENTITY_VERIFICATION_SHOW_MODAL_QUERY_PARAM_VALUE, SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE, SAMPLES_REQUEST_MODAL, SHOPIFY_PLAN_UPSELL_MODAL, SHOW_MODAL_QUERY_PARAM, TEAM_MEMBERS_MODAL_QUERY_PARAM, RESELLER_CERTIFICATE_MODAL, CONDUCTOR_MODAL_QUERY_PARAM, REQUEST_UNLISTED_PRODUCTS_MODAL } from "@faire/retailer-visitor-shared/components/App/AppModals/consts";
import { useConductorComponent } from "@faire/retailer-visitor-shared/features/Conductor/useConductorComponent";
import { SignUpType } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { AppHistory } from "@faire/retailer-visitor-shared/packages/core/services/AppHistory";
import { getSettingEnableUnlistedProductsRequests } from "@faire/retailer-visitor-shared/settings/getSettingEnableUnlistedProductsRequests";
import { RouteMatcher } from "@faire/web--source/common/routes/RouteMatcher";
import { singletonGetter } from "@faire/web--source/common/singletons/getter";
import { ConductorSurface } from "@faire/web-api--source/indigofair/data/ConductorSurface";
import { route as brandInvoiceTokenRoute } from "@faire/web-api--source/routes/brand-invoice/brandInvoiceToken";
import { route as brandPageRoute } from "@faire/web-api--source/routes/brand/brandToken";
import { route as cartRoute } from "@faire/web-api--source/routes/cart";
import { route as checkoutRoute } from "@faire/web-api--source/routes/checkout";
import { route as productBasedCollectionPageRoute } from "@faire/web-api--source/routes/product-based-collection/product_based_collection_token";
import { route as productRoute } from "@faire/web-api--source/routes/product/productToken";
import { computed } from "mobx";
import qs from "query-string";
import { useLocation } from "react-router-dom";
export var ModalType;
(function(ModalType) {
    ModalType[ModalType["SIGN_UP"] = 0] = "SIGN_UP";
    ModalType[ModalType["SIGN_IN"] = 1] = "SIGN_IN";
    ModalType[ModalType["PRODUCT"] = 2] = "PRODUCT";
    ModalType[ModalType["COLLECTION"] = 3] = "COLLECTION";
    ModalType[ModalType["PAYMENT_OPTIONS"] = 4] = "PAYMENT_OPTIONS";
    ModalType[ModalType["NON_BM_TIER_1"] = 5] = "NON_BM_TIER_1";
    ModalType[ModalType["NON_BM_TIER_2"] = 6] = "NON_BM_TIER_2";
    ModalType[ModalType["SIGN_IN_FROM_EMAIL"] = 7] = "SIGN_IN_FROM_EMAIL";
    ModalType[ModalType["OPENING_ORDER_INCENTIVES_MODAL"] = 8] = "OPENING_ORDER_INCENTIVES_MODAL";
    ModalType[ModalType["INSIDER_SIGN_UP"] = 9] = "INSIDER_SIGN_UP";
    ModalType[ModalType["IDENTITY_VERIFICATION"] = 10] = "IDENTITY_VERIFICATION";
    ModalType[ModalType["FAIRE_DIRECT_FOI"] = 11] = "FAIRE_DIRECT_FOI";
    ModalType[ModalType["FAIRE_DIRECT_MARKETPLACE_INCENTIVE_MODAL"] = 12] = "FAIRE_DIRECT_MARKETPLACE_INCENTIVE_MODAL";
    ModalType[ModalType["FIRST_ORDER_INCENTIVE_MODAL"] = 13] = "FIRST_ORDER_INCENTIVE_MODAL";
    ModalType[ModalType["FAIRE_DIRECT_CREDIT_FAQ"] = 14] = "FAIRE_DIRECT_CREDIT_FAQ";
    ModalType[ModalType["INSIDER_INTERNATIONAL_ENROLMENT"] = 15] = "INSIDER_INTERNATIONAL_ENROLMENT";
    ModalType[ModalType["INSIDER_ENROLMENT"] = 16] = "INSIDER_ENROLMENT";
    ModalType[ModalType["LINK_PLAID_MODAL"] = 17] = "LINK_PLAID_MODAL";
    ModalType[ModalType["FREE_RETURNS_MODAL"] = 18] = "FREE_RETURNS_MODAL";
    ModalType[ModalType["SHOPIFY_PLAN_UPSELL"] = 19] = "SHOPIFY_PLAN_UPSELL";
    ModalType[ModalType["ACH_PROACTIVE_LIMIT_INCREASE_UPSELL"] = 20] = "ACH_PROACTIVE_LIMIT_INCREASE_UPSELL";
    ModalType[ModalType["ACH_TERMS_PRE_APPROVAL_MODAL"] = 21] = "ACH_TERMS_PRE_APPROVAL_MODAL";
    ModalType[ModalType["SAMPLES_REQUEST_MODAL"] = 22] = "SAMPLES_REQUEST_MODAL";
    ModalType[ModalType["TERMS_PRE_APPROVAL_MODAL"] = 23] = "TERMS_PRE_APPROVAL_MODAL";
    ModalType[ModalType["CONDUCTOR_FUNCTIONAL_MODAL"] = 24] = "CONDUCTOR_FUNCTIONAL_MODAL";
    ModalType[ModalType["TEAM_MEMBERS_MODAL"] = 25] = "TEAM_MEMBERS_MODAL";
    ModalType[ModalType["PROFILE_PICTURE_UPLOAD_MODAL"] = 26] = "PROFILE_PICTURE_UPLOAD_MODAL";
    ModalType[ModalType["CONDUCTOR_MODAL"] = 27] = "CONDUCTOR_MODAL";
    ModalType[ModalType["DIGEST_PAGE_ENTRYPOINT_MODAL"] = 28] = "DIGEST_PAGE_ENTRYPOINT_MODAL";
    ModalType[ModalType["RESELLER_CERTIFICATE_MODAL"] = 29] = "RESELLER_CERTIFICATE_MODAL";
    ModalType[ModalType["RESET_PASSWORD_MODAL"] = 30] = "RESET_PASSWORD_MODAL";
    ModalType[ModalType["CONSUMER_MODE_REDIRECT"] = 31] = "CONSUMER_MODE_REDIRECT";
    ModalType[ModalType["REQUEST_UNLISTED_PRODUCTS_MODAL"] = 32] = "REQUEST_UNLISTED_PRODUCTS_MODAL";
})(ModalType || (ModalType = {}));
/**
 * @deprecated prefer to use `useAppModal`
 */ export var AppModalStore = /*#__PURE__*/ function() {
    "use strict";
    function AppModalStore() {
        _class_call_check(this, AppModalStore);
    }
    _create_class(AppModalStore, [
        {
            key: "showingModalType",
            get: function get() {
                var _AppHistory_get_location;
                var _AppHistory_get_location_pathname;
                return getShowingModalType({
                    pathname: (_AppHistory_get_location_pathname = (_AppHistory_get_location = AppHistory.get().location) === null || _AppHistory_get_location === void 0 ? void 0 : _AppHistory_get_location.pathname) !== null && _AppHistory_get_location_pathname !== void 0 ? _AppHistory_get_location_pathname : "",
                    search: AppHistory.get().history.location.search,
                    // currently hardcoded isConductor, should eventually get rid of MobX so we can properly use useConductorComponent()
                    isConductor: false
                });
            }
        },
        {
            key: "isModalShowing",
            get: function get() {
                return this.showingModalType !== undefined;
            }
        }
    ]);
    return AppModalStore;
}();
AppModalStore.get = singletonGetter(AppModalStore);
__decorate([
    computed
], AppModalStore.prototype, "showingModalType", null);
__decorate([
    computed
], AppModalStore.prototype, "isModalShowing", null);
export var useAppModal = function() {
    var _conductorSduiViewLayout_content;
    var location = useLocation();
    var _useConductorComponent = useConductorComponent({
        surface: ConductorSurface.SITE_WIDE_MODAL
    }), conductorBuilderModelName = _useConductorComponent.conductorBuilderModelName, conductorSduiViewLayout = _useConductorComponent.conductorSduiViewLayout;
    var showingModalType = getShowingModalType({
        pathname: location.pathname,
        search: location.search,
        isConductor: !!conductorBuilderModelName || !!(conductorSduiViewLayout === null || conductorSduiViewLayout === void 0 ? void 0 : (_conductorSduiViewLayout_content = conductorSduiViewLayout.content) === null || _conductorSduiViewLayout_content === void 0 ? void 0 : _conductorSduiViewLayout_content.length)
    });
    return {
        showingModalType: showingModalType,
        isModalShowing: showingModalType !== undefined
    };
};
var getShowingModalType = function(params) {
    var pathname = params.pathname, search = params.search, isConductor = params.isConductor;
    var _qs_parse = qs.parse(search), signUp = _qs_parse.signUp, signIn = _qs_parse.signIn, product = _qs_parse.product, collection = _qs_parse.collection, paymentOptions = _qs_parse["payment-options"], nonBMTier1 = _qs_parse.nonBMTier1, nonBMTier2 = _qs_parse.nonBMTier2, quickLogin = _qs_parse.quickLogin, openingOrderIncentives = _qs_parse.openingOrderIncentives, insiderSignUp = _qs_parse.insiderSignUp, insiderInternationalEnrolment = _qs_parse.insiderInternationalEnrolment, insiderEnrolment = _qs_parse.insiderEnrolment, showModal = _qs_parse[SHOW_MODAL_QUERY_PARAM], linkPlaid = _qs_parse.linkPlaid, achProactiveLimitIncrease = _qs_parse.achProactiveLimitIncrease, achTermsPreApproval = _qs_parse.achTermsPreApproval, termsPreApproval = _qs_parse.termsPreApproval, resetPassword = _qs_parse.resetPassword, consumerModeRedirect = _qs_parse.consumerModeRedirect;
    var skipProductModalRouteMatcher = RouteMatcher.of(cartRoute, brandPageRoute, productBasedCollectionPageRoute, checkoutRoute, brandInvoiceTokenRoute, productRoute);
    var skipProductModal = skipProductModalRouteMatcher.match(pathname);
    if (quickLogin) {
        return ModalType.SIGN_IN_FROM_EMAIL;
    } else if (signUp) {
        if (signUp !== SAMPLE_PROSPECTING_SIGN_IN_QUERY_PARAM_VALUE && signUp !== SignUpType.FAIRE_DIRECT_REQUIRE_EMAIL) {
            return ModalType.SIGN_UP;
        }
    } else if (signIn) {
        return ModalType.SIGN_IN;
    } else if (resetPassword) {
        return ModalType.RESET_PASSWORD_MODAL;
    } else if (consumerModeRedirect) {
        return ModalType.CONSUMER_MODE_REDIRECT;
    } else if (product && !skipProductModal) {
        return ModalType.PRODUCT;
    } else if (collection) {
        return ModalType.COLLECTION;
    } else if (paymentOptions) {
        return ModalType.PAYMENT_OPTIONS;
    } else if (nonBMTier1) {
        return ModalType.NON_BM_TIER_1;
    } else if (nonBMTier2) {
        return ModalType.NON_BM_TIER_2;
    } else if (openingOrderIncentives) {
        return ModalType.OPENING_ORDER_INCENTIVES_MODAL;
    } else if (insiderSignUp) {
        return ModalType.INSIDER_SIGN_UP;
    } else if (insiderInternationalEnrolment) {
        return ModalType.INSIDER_INTERNATIONAL_ENROLMENT;
    } else if (insiderEnrolment) {
        return ModalType.INSIDER_ENROLMENT;
    } else if (linkPlaid) {
        return ModalType.LINK_PLAID_MODAL;
    } else if (showModal === IDENTITY_VERIFICATION_SHOW_MODAL_QUERY_PARAM_VALUE) {
        return ModalType.IDENTITY_VERIFICATION;
    } else if (showModal === FIRST_ORDER_INCENTIVE_MODAL) {
        return ModalType.FIRST_ORDER_INCENTIVE_MODAL;
    } else if (showModal === FAIRE_DIRECT_FOI) {
        return ModalType.FAIRE_DIRECT_FOI;
    } else if (showModal === FAIRE_DIRECT_MARKETPLACE_INCENTIVE_MODAL) {
        return ModalType.FAIRE_DIRECT_MARKETPLACE_INCENTIVE_MODAL;
    } else if (showModal === FAIRE_DIRECT_CREDIT_FAQ) {
        return ModalType.FAIRE_DIRECT_CREDIT_FAQ;
    } else if (showModal === FREE_RETURNS_MODAL_QUERY_PARAM_VALUE) {
        return ModalType.FREE_RETURNS_MODAL;
    } else if (showModal === SHOPIFY_PLAN_UPSELL_MODAL) {
        return ModalType.SHOPIFY_PLAN_UPSELL;
    } else if (achProactiveLimitIncrease) {
        return ModalType.ACH_PROACTIVE_LIMIT_INCREASE_UPSELL;
    } else if (achTermsPreApproval) {
        return ModalType.ACH_TERMS_PRE_APPROVAL_MODAL;
    } else if (showModal === SAMPLES_REQUEST_MODAL) {
        return ModalType.SAMPLES_REQUEST_MODAL;
    } else if (termsPreApproval) {
        return ModalType.TERMS_PRE_APPROVAL_MODAL;
    } else if (showModal === CONDUCTOR_FUNCTIONAL_MODAL) {
        return ModalType.CONDUCTOR_FUNCTIONAL_MODAL;
    } else if (showModal === TEAM_MEMBERS_MODAL_QUERY_PARAM) {
        return ModalType.TEAM_MEMBERS_MODAL;
    } else if (showModal === DIGEST_ENTRYPOINT_MODAL_QUERY_PARAM) {
        return ModalType.DIGEST_PAGE_ENTRYPOINT_MODAL;
    } else if (showModal === RESELLER_CERTIFICATE_MODAL) {
        return ModalType.RESELLER_CERTIFICATE_MODAL;
    } else if (getSettingEnableUnlistedProductsRequests() && showModal === REQUEST_UNLISTED_PRODUCTS_MODAL) {
        return ModalType.REQUEST_UNLISTED_PRODUCTS_MODAL;
    } else if (showModal === CONDUCTOR_MODAL_QUERY_PARAM) {
        return ModalType.CONDUCTOR_MODAL;
    }
    // for SDUI purposes
    if (isConductor) {
        return ModalType.CONDUCTOR_MODAL;
    }
    return undefined;
};
